import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import OpenInterestBreakupFull from './open-interest-breakup-full';

const OpenInterestBreakupFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <OpenInterestBreakupFull {...props} />
    </QueryClientProvider>
  );
};

export { OpenInterestBreakupFullWidget }
